<ng-container *transloco="let t">
  <h3 class="mb-2 text-3xl font-semibold text-gray-800 dark:text-gray-100">{{ t("login.login_header") }}</h3>
  <p class="mb-6 text-gray-500 dark:text-gray-400">{{ t("login.login_header_description") }}</p>
  @if (error(); as error) {
    <IAlert class="mb-6 block" type="error" [title]="error" />
  }
  <ILoginForm [isLoading]="loading()" (login)="login($event)" />

  <p class="mt-6 text-center text-sm text-gray-500 dark:text-gray-400">
    {{ t("login.dont_have_an_account") }}
    <a class="link" routerLink="/register">{{ t("login.create_an_account") }}</a>
  </p>
</ng-container>
